const PREFIX = '@auth:reset_password/';

export const RESET_PASSWORD_STEP = {
    VERIFY_CODE: `${PREFIX}verify_code`,
    SET_PASSWORD: `${PREFIX}set_password`,
};
